"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.default = (0, graphql_tag_1.default)`
  fragment notificationStatisticShortFields on NotifyStatisticSchema {
    total {
      count
      ownedArea
      votePercent
    }
    receive {
      total {
        count
        ownedArea
        votePercent
      }
      push {
        count
        ownedArea
        votePercent
      }
      tgBot {
        count
        ownedArea
        votePercent
      }
      email {
        count
        ownedArea
        votePercent
      }
      sms {
        count
        ownedArea
        votePercent
      }
    }
    notReceive {
      total {
        count
        ownedArea
        votePercent
      }
      notRegistered {
        count
        ownedArea
        votePercent
      }
      disableNotify {
        count
        ownedArea
        votePercent
      }
      spammers {
        count
        ownedArea
        votePercent
      }
      isRegistered {
        count
        ownedArea
        votePercent
      }
      noOwnerships {
        count
        ownedArea
        votePercent
      }
      notContacts {
        count
        ownedArea
        votePercent
      }
      enableTgBot {
        count
        ownedArea
        votePercent
      }
    }
    needLimit {
      total {
        count
        ownedArea
        votePercent
      }
      email {
        count
        ownedArea
        votePercent
      }
      sms {
        count
        ownedArea
        votePercent
      }
    }
  }
`;